// RedTrack utility functions
import { getTrackingParams } from "./tracking";

const SWIPEY_BASE_URL = process.env.REACT_APP_SWIPEY_BASE_URL;

export const getRedTrackClickId = () => {
  // Try to get clickId from RedTrack
  if (window.rtrk && typeof window.rtrk.getClickId === "function") {
    return window.rtrk.getClickId();
  }

  // Fallback to URL parameter
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get("clickid") || urlParams.get("rtkcid") || "";
};

export const getAllUrlParameters = () => {
  return getTrackingParams();
};

export const buildPaywallUrl = (authToken, authType = "login_paywall") => {
  const paywallUrl = new URL(SWIPEY_BASE_URL + "/paywall");

  // Add auth token and type
  paywallUrl.searchParams.set("auth_token", authToken);
  paywallUrl.searchParams.set("auth_type", authType);

  // Add clickId if available
  const clickId = getRedTrackClickId();
  if (clickId) {
    paywallUrl.searchParams.set("clickid", clickId);
    paywallUrl.searchParams.set("rtkcid", clickId);
  }

  // Add all tracking parameters from our tracking system
  const trackingParams = getTrackingParams();

  Object.entries(trackingParams).forEach(([key, value]) => {
    if (value) {
      paywallUrl.searchParams.set(key, value);
    }
  });

  return paywallUrl.toString();
};
